"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SeatsTwo = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var SeatsTwo = function SeatsTwo(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M1.82 3.2A1.6 1.6 0 00.243 5.074l.989 5.677c.237-.218.554-.351.901-.351H6.4l-.89-5.204A2.4 2.4 0 003.145 3.2H1.82zm5.56 7.2l-.928-5.326A1.6 1.6 0 018.028 3.2h.848a2.4 2.4 0 012.366 1.996l.888 5.204H7.38zm-.869.8H2.133a.534.534 0 00-.533.517A2.4 2.4 0 003.607 12.8h3.128a1.858 1.858 0 01-.335-1.067c0-.19.04-.37.11-.533zm2.875 1.6H14.4a.8.8 0 000-1.6H9.386a1.593 1.593 0 010 1.6z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11.2H2.133a.533.533 0 00-.533.533c0 .59.478 1.067 1.067 1.067H8a.8.8 0 000-1.6z",
    fill: "currentColor"
  }));
};

exports.SeatsTwo = SeatsTwo;
var _default = SeatsTwo;
exports.default = _default;